
















































import { Component, Vue } from "vue-property-decorator";
import { LoginUserModel } from "@/models/auth/LoginUserModel";
import { ACTION_LOGIN_ADMIN } from "@/store/actions-types";
import { RESET_AUTH_STATE } from "@/store/mutations-types";

@Component
/**
 * Login functionality for admins/mods
 */
export default class Login extends Vue {
  userModel: LoginUserModel = new LoginUserModel();

  /**
   * indicate login request running
   */
  public isLoggingIn = false;

  /**
   * is login form complete
   */
  get enableLogin(): string {
    return this.userModel.username && this.userModel.password;
  }

  /**
   * User returns after its session ended
   */
  get wasLoggedOut(): boolean {
    // eslint-disable-next-line
    return this.$route.query?.unauthenticated === 'true'
  }

  /**
   * validate credentials on server side and get auth jwt
   * @return boolean
   */
  async login(): Promise<void> {
    this.$store.commit(RESET_AUTH_STATE);
    try {
      this.isLoggingIn = true;
      await this.$store.dispatch(ACTION_LOGIN_ADMIN, this.userModel);
    } finally {
      this.isLoggingIn = false;
    }
  }
}
